import {
    Button,
    Chip,
    TableCell,
    TableContainer,
    Box,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const ActionsBar = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
    flexWrap: 'wrap',
    gap: '15px',
});

export const UploadButton = styled(Button)({
    backgroundColor: 'var(--secondary-main)',
    color: '#fff',
    padding: '8px 20px',

    '&:hover': {
        backgroundColor: 'var(--secondary-dark)',
    },
});

export const FilterSection = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    flexWrap: 'wrap',

    '@media (max-width: 768px)': {
        width: '100%',
        justifyContent: 'flex-end',
    },
});

export const StyledTableContainer = styled(TableContainer)({
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    borderRadius: '8px',
    marginBottom: '20px',

    '& .MuiTable-root': {
        tableLayout: 'fixed',
        width: '100%',
    },

    '& .MuiTableCell-root': {
        padding: '12px 16px',
        textAlign: 'left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
});

export const TableHeader = styled(TableCell)({
    backgroundColor: 'var(--primary-main)',
    color: '#fff',
    fontWeight: 500,
    textAlign: 'left !important',
});

export const StatusCell = styled(TableCell)(() => ({
    alignItems: 'center',
    gap: '5px',
}));

export const StatusBadge = styled(Chip)(({ status }) => {
    let bgColor = 'rgba(0, 0, 0, 0.1)';
    let textColor = 'rgba(0, 0, 0, 0.7)';

    if (status === 'SUCCESS') {
        bgColor = 'rgba(46, 184, 92, 0.1)';
        textColor = '#2eb85c';
    } else if (status === 'IN_PROGRESS' || status === 'NOT_STARTED' || status === 'CANCELLED') {
        bgColor = 'rgba(185, 161, 104, 0.1)';
        textColor = 'var(--secondary-main)';
    } else if (status === 'ERROR') {
        bgColor = 'rgba(229, 62, 62, 0.1)';
        textColor = '#e53e3e';
    }

    return {
        backgroundColor: bgColor,
        color: textColor,
        fontWeight: 500,
        borderRadius: '12px',
    };
});

export const ActionButton = styled(Button)({
    minWidth: 'unset',
    padding: '6px 8px',
    margin: '0 3px',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)',
    '&:hover': {
        backgroundColor: 'rgba(197, 171, 110, 0.08)',
    },
});

export const ModalBox = styled(Box)({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxWidth: '900px',
    maxHeight: '85vh',
    backgroundColor: 'var(--background-paper)',
    border: '1px solid #ccc',
    borderRadius: '8px',
    boxShadow: 24,
    padding: '0',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
});

export const DeleteModalBox = styled(Box)({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    backgroundColor: 'var(--background-paper)',
    border: '1px solid #ccc',
    borderRadius: '8px',
    boxShadow: 24,
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
});

export const TabContentBox = styled(Box)({
    padding: '24px',
    backgroundColor: 'var(--background-paper)',
});

export const PreformattedText = styled('pre')({
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word',
    backgroundColor: '#f5f5f5',
    padding: '15px',
    borderRadius: '4px',
    overflowY: 'auto',
    fontFamily: 'monospace',
    fontSize: '0.9em',
});